import {defineStore} from "pinia";

export const useAssignedVehiclesList = defineStore('assignedVehiclesList',{
  state:() => ({
    vehicles: [],
    unAssignedVehicles: [],
    assignedVehiclesOnLoad: [],
    vehicleSpecFiltersLoaded: false,
  }),
  actions: {
    // push a new vehicle into the array
    pushVehicle(vehicle){
      const index = this.unAssignedVehicles.findIndex(item => item.assigned_vehicle_id === vehicle.assigned_vehicle_id);
      if( index !== -1){
        this.unAssignedVehicles.splice(index,1);
      }
      this.vehicles.push(vehicle);
    },

    popVehicle(index){
      if(index >= 0 && index < this.vehicles.length){
        this.unAssignedVehicles.push(this.vehicles[index]);
        this.vehicles.splice(index,1);
      }
    },

    // Populates the vehicles array with data from the server
    // Assumes "data" is an array of vehicles
    populateVehicles(data) {
      this.vehicles = data;
      this.assignedVehiclesOnLoad = JSON.stringify(data);
      this.unAssignedVehicles = [];
    },

    updateFilterStatus(loaded){
      this.vehicleSpecFiltersLoaded = loaded;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/AssignedVehiclesList.js